<template>
  <svg
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.5 0.0634766C11.6073 0.0635596 14.9373 3.39272 14.9375 7.5C14.9374 11.6074 11.6074 14.9374 7.5 14.9375C3.39272 14.9373 0.0635586 11.6073 0.0634766 7.5C0.0637254 3.39282 3.39282 0.0637254 7.5 0.0634766ZM7.5 1.0127C3.91749 1.01294 1.01294 3.91749 1.0127 7.5C1.01278 11.0826 3.91739 13.988 7.5 13.9883C11.0827 13.9882 13.9882 11.0827 13.9883 7.5C13.988 3.91739 11.0826 1.01278 7.5 1.0127ZM7.50098 5.86816C7.77685 5.86845 8.00092 6.09224 8.00098 6.36816V10.3984H9.13281V11.3984H5.86816V10.3984H7.00098V6.86816H5.86816V5.86816H7.50098ZM7.5 3.25391C7.96907 3.25393 8.34961 3.63444 8.34961 4.10352C8.3494 4.57242 7.96895 4.9531 7.5 4.95312C7.0312 4.95293 6.65158 4.57231 6.65137 4.10352C6.65137 3.63454 7.03108 3.2541 7.5 3.25391Z"
      fill="currentColor"
    />
  </svg>
</template>
